import moment from "moment";


import useAssignedStock from "./Hooks/useAssignedStock";
import useReduxStore from "../../hooks/useReduxStore";
import Table from "../../components/Table/Table";
import { Pagination } from "../../components/pagination/Pagination";

const AssingedStockProfile = () => {
  const { data, methods } = useAssignedStock();
  const { selector: user } = useReduxStore("auth");
  const { controller, totalCount, employeeList } = data;
  const { handlePagination, unAssignStock } = methods;

  const TableHead = [
    { label: "#", id: "" },
    { label: "ProductName", id: "productName" },
    { label: "Assign/Unassign Quantity", id: "assignQuantity" },
    { label: "Assigned By", id: "created" },
    { label: "Date of Assign", id: "Date" },
    { label: "Type", id: "type" },
    { label: "Remarks", id: "remark" },
    // { label: "Action", id: "action" },
  ];

  return (
    <div>
      <div className="mt-2">
        <table className="table">
          <Table TableHeadData={TableHead} rowCount={TableHead?.length} />
          <tbody>
            {employeeList?.map((item, index) => {
              return (
                <tr
                  className="text-start rounded-row"
                  style={{
                    borderRadius: "50px",
                    backgroundColor: "#fff",
                  }}
                >
                  <td className="table-link">
                    {controller.rowsPerPage * (controller.page - 1) + index + 1}{" "}
                  </td>
                  <td>
                    {item?.inventory_id?.productName}
                  </td>
                  <td className="">{item?.assignQuantity}</td>
                  <td className="">{item?.createdby_id?.firstName}</td>
                  <td className="">
                    {moment(item?.dateOfAssign).format("YYYY-MM-DD")}
                  </td>
                  <td className="">{item?.type}</td>
                  <td className="">{item?.remarks}</td>

                  {/* <td>
                    <div className="dropdown p-0 align-items-center justify-content-center">
                      <i
                        className="fas fa-ellipsis-v pointer p-2"
                        id="dropdownMenuLink"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{
                          cursor: user?.userInfo?.permission?.inventory?.edit
                            ?.value
                            ? "pointer"
                            : "not-allowed",
                        }}
                      />
                      <ul
                        className="dropdown-menu"
                        aria-labelledby={`dropdown-${item._id}`}
                      >
                        <li
                          className="dropdown-item"
                          style={{ cursor: "pointer" }}
                          onClick={() => unAssignStock(item._id)}
                        >
                          Unassigned Stock
                        </li>
                      </ul>
                    </div>
                  </td> */}
                </tr>
              );
            })}

            <td colSpan={"20"}>
              {totalCount > 10 && (
                <Pagination
                  style={{ backgroundColor: "#fff" }}
                  count={totalCount}
                  controller={controller}
                  setController={handlePagination}
                />
              )}
            </td>
          </tbody>
        </table>
                {!employeeList?.length && (
                    <div className="text-center">No record found</div>
                  )}
      </div>
    </div>
  );
};

export default AssingedStockProfile;
